import ActiveQuoteRootPage from "../components/ActiveQuoteRootPage";

export function create() {
  return <ActiveQuoteRootPage />;
}
